<template>
  <v-card
    flat
    class="d-flex justify-space-between pa-2"
  >
    <ReflectionInfo :title="reflection.title" :template-id="reflection.template_id" />
    <div class="reflection-card__actions">
      <v-icon
        v-if="addedIcon"
        class="pa-1"
        :size="14"
        color="green"
      >
        add_circle
      </v-icon>
      <v-icon
        v-if="removedIcon"
        class="pa-1"
        :size="14"
        color="red"
      >
        remove_circle
      </v-icon>
      <v-icon
        v-if="reflectionUrl"
        class="pa-1"
        :size="14"
        @click.stop="openReflection"
      >
        open_in_new
      </v-icon>
      <v-icon
        class="pa-1"
        :size="14"
        @click.stop="close"
      >
        close
      </v-icon>
    </div>
  </v-card>
</template>

<script>
import ReflectionInfo from './ReflectionInfo';

export default {
  name: 'ReflectionDocumentCard',
  components: {
    ReflectionInfo,
  },
  props: {
    reflection: {
      type: Object,
      required: true,
    },
    addedIcon: {
      type: Boolean,
      default: false,
    },
    removedIcon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    reflectionUrl() {
      const websiteUrl = process.env.VUE_APP_ROOT_URL;
      if (!websiteUrl) return undefined;

      return `${websiteUrl}/reflections/${this.reflection.id}`;
    },
  },
  methods: {
    close() {
      this.$emit('close', this.reflection);
    },
    openReflection() {
      window.open(this.reflectionUrl, '_blank');
    },
  },
};
</script>

<style scoped>
.reflection-card__actions {
  flex-shrink: 0;
  margin-left: 16px;
}
</style>
